module.exports = __webpack_public_path__ + "images/light-fresh-556ee8683dc6bcf4fab52f461353665f.jpg";